<div class="flex">
  <button
    type="button"
    class="btn relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
    aria-pressed="false"
    (click)="emitChange()"
    [ngClass]="{ 'bg-primary': on, 'bg-gray-200': !on }">
    <span
      aria-hidden="true"
      class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-black shadow transform ring-0 transition ease-in-out duration-200"
      [ngClass]="{ 'translate-x-5': on, 'translate-x-0': !on }"></span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="text-black m-auto"
      style="width: 18px; height: 18px"
      viewBox="0 0 20 20"
      fill="currentColor">
      <path
        fill-rule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clip-rule="evenodd" />
    </svg>
  </button>
</div>
